export default {
  monthsKeysByIndex: {
    0: 'January',
    1: 'February',
    2: 'March',
    3: 'April',
    4: 'May',
    5: 'June',
    6: 'July',
    7: 'August',
    8: 'September',
    9: 'October',
    10: 'November',
    11: 'December',
  },
  monthsShortKeysByIndex: {
    0: 'Jan.',
    1: 'Feb.',
    2: 'Mar.',
    3: 'Apr.',
    4: 'May',
    5: 'Jun.',
    6: 'Jul.',
    7: 'Aug.',
    8: 'Sep.',
    9: 'Oct.',
    10: 'Nov.',
    11: 'Dec.',
  },
  weekdaysKeysByIndex: {
    0: 'Su',
    1: 'Mo',
    2: 'Tu',
    3: 'We',
    4: 'Th',
    5: 'Fr',
    6: 'Sa',
  },
  button: {
    ok: 'Select',
    cancel: 'Reset',
  },
};
